export class InvariantError extends Error {
    public fieldName?: string;

    constructor(message: string, fieldName?: string) {
        super(message);
        this.fieldName = fieldName;
    }
}
